import React from "react";
import "./DynamicTable.css";
import Autosuggest from "react-autosuggest";
import { object } from "yup";

class DynamicTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [{}],
      focusOnAddRow: true,
    };
    let rowsDummy = [{}];
    for (var tableItem of this.props.tableItems) {
      rowsDummy[0][tableItem.name] = "";
    }
    this.props.setPageStateByField(this.props.fieldMapping, rowsDummy);
  }
  handleChange = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.props.pageStateArray];
    rows[idx][name] = value;
    // this.setState({
    //   rows,
    // });  
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };
  handleChangeByField = (name, value, idx) => {
    const rows = [...this.props.pageStateArray];
    rows[idx][name] = String(value);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  updateSuggestionValueInState = (idx, objectToUpdate) => {
    const rows = [...this.props.pageStateArray];
    let rowObject = rows[idx];
    rowObject = { ...rowObject, ...objectToUpdate };
    rows[idx] = rowObject;
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };
  handleAddRow = () => {
    /**
     * Check if any field is empty and don't let the row add
     * if any field is empty.
     */
    for (var item_index in this.props.pageStateArray) {
      let item = this.props.pageStateArray[item_index];
      const { weightMode } = this.props;
      console.log('iiii', item)
      // for (var key in item) {
      //   if (key == "rate_info"){
      //     continue
      //   }
      //   if (key == "truck_size"){
      //     continue
      //   }
      //   if (item[key] == "") {
      //     return;
      //   }
      // }

      const skipFieldsByWeightMode = {
        LBH: ["cft", "inch_cm", "rate_info", "liter", "vehicle_size", "vehicle_type", "box_capacity"],
        CFT: ["l", "b", "h", "inch_cm", "rate_info", "liter", "vehicle_size", "vehicle_type", "box_capacity"],
        Liter: ["l", "b", "h", "cft", "inch_cm", "rate_info", "vehicle_size", "vehicle_type", "box_capacity"],
        Normal: ["l", "b", "h", "cft", "inch_cm", "rate_info", "liter", "vehicle_size", "vehicle_type", "box_capacity"]
      };
      
      // const skipFieldsByShippingType = {
      //   1: ["l", "b", "h", "cft", "inch_cm", "liter"]
      // };

      const skipFieldsByShippingType = {};  // prevent error, not used anymore
      
      const weightModeSkipSet = new Set(skipFieldsByWeightMode[weightMode] || []);
      const shippingTypeSkipSet = new Set(skipFieldsByShippingType[this.props.pageState?.type_of_shipping] || []);
      
      for (let key in item) {
        if (weightModeSkipSet.has(key) || shippingTypeSkipSet.has(key)) {
          continue;
        }
  
        if (item[key] === "") {
          console.log(`Field "${key}" is empty. Row will not be added.`);
          return;
        }
      }
    }
    const item = {};
    for (var tableItem of this.props.tableItems) {
        // console.log({tableItem});
      if (tableItem.name == "packing_type") {
        item[tableItem.name] = "1";
        continue;
      }
      if (tableItem.name == "new_row") {
        item[tableItem.name] = "N";
        continue;
      }
      if(tableItem.name == "unit" && this.props.fieldMapping == "item_in" && this.props.pageState?.type_of_shipping !== 1) {
        item[tableItem.name] = "C";
        continue;
      }
      // Set "unit" to "F" when type_of_shipping is 1
      if (tableItem.name == "unit" && this.props.fieldMapping == "item_in" && this.props.pageState?.type_of_shipping === 1) {
        item[tableItem.name] = "F"; 
        continue;
      }
      
      // AUTO COPY TOTAL_KMS FOR ALL NEW ROWS
      if (tableItem.name === "total_kms") {
        item[tableItem.name] = this.props.pageStateArray[0]?.total_kms || "";
        continue;
      }

      item[tableItem.name] = "";
    }
    console.log("table item", item);

    this.setState({
      rows: [...this.state.rows, item],
      focusOnAddRow: true,
    });
    this.props.setPageStateByField(this.props.fieldMapping, [
      ...this.props.pageStateArray,
      item,
    ]);
  };

  handleRemoveRow = () => {
    // this.setState({
    //   rows: this.state.rows.slice(0, -1),
    // });
    let rows = this.props.pageStateArray;
    rows = rows.slice(0, -1);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.props.pageStateArray];
    if (rows.length <= 1) {
      return;
    }
    rows.splice(idx, 1);
    this.props.setPageStateByField(this.props.fieldMapping, rows);
  };

  onKeyPress =  (e, index, totalLength, fieldInfoObject) => {
    const keyString = String(e.key);
    const { weightMode } = this.props;
    console.log("inside !!!");

    // if (
    //   this.props.pageState?.type_of_shipping === 1 &&
    //   fieldInfoObject.name === "packing_type" &&
    //   keyString === "Enter"
    // ) {
    //   e.preventDefault();
    //   this.props.makeFocusOnParticularFieldForItem(
    //     this.props.fieldMapping,
    //     index,
    //     "pkgs"
    //   );
    //   return;
    // }

    if (
      this.props.pageState?.type_of_shipping === 2 && 
      this.props.pageState?.pay_type === "4" && 
      this.props.pageState?.type_of_weight ===13
    ) {
      if (fieldInfoObject.name === "unit" && keyString === "Enter") {
        e.preventDefault();
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "packing_type"
        );
        return;
      }

      if (fieldInfoObject.name === "packing_type" && keyString === "Enter") {
        e.preventDefault();
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "pkgs"
        );
        return;
      }
    }

    if (
      fieldInfoObject.name === "unit" &&
      keyString === "Enter" &&
      this.props.pageState?.type_of_shipping === 1 &&
      this.props.pageState?.is_wipro === true
    ) {
      e.preventDefault();
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "vehicle_type"
      );
      return;
    }

    if (
      fieldInfoObject.name === "vehicle_type" &&
      keyString === "Enter" &&
      this.props.pageState?.type_of_shipping === 1 &&
      this.props.pageState?.is_wipro === true &&
      this.props.pageState?.type_of_weight === 15
    ) {
      e.preventDefault();
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "vehicle_size"
      );
      return;
    }

    if (
      fieldInfoObject.name === "vehicle_type" &&
      keyString === "Enter" &&
      this.props.pageState?.type_of_shipping === 1 &&
      this.props.pageState?.is_wipro === true
    ) {
      e.preventDefault();
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "packing_type"
      );
      return;
    }

    // Automatic value updation block
    if (fieldInfoObject.name == "unit" && keyString == "Enter") {
      if ("rate_info" in this.props.pageStateArray[index]) {
          this.props.setOverlay(true);
        //   await new Promise(resolve => setTimeout(resolve, 2000));
        let rateInfoObject = this.props.pageStateArray[index]["rate_info"];
        for (let i = 0; i < rateInfoObject.length; i++) {
          if (
            rateInfoObject[i].unit.toUpperCase() ==
            this.props.pageStateArray[index].unit.toUpperCase()
          ) {
            if (
              "rate" in rateInfoObject[i] &&
              this.props.pageStateArray[index].unit.toUpperCase() != "F"
            ) {
              this.handleChangeByField("rate", rateInfoObject[i].rate, index);
            }
            if ("weight" in rateInfoObject[i]) {
              this.handleChangeByField(
                "weight",
                rateInfoObject[i].weight,
                index
              );
            }
          }
        }
        this.props.setOverlay(false);
      }
    }

    if (this.props.weightMode === "CFT" && fieldInfoObject.name === "packing_type" && keyString === "Enter") {
      e.preventDefault(); 
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "cft" 
      );
      return;
    }
    if (this.props.pageState?.type_of_shipping === 1 && fieldInfoObject.name == "unit" && keyString == "Enter") {
      e.preventDefault(); 
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "packing_type" 
      );
      return;
    }

    if (this.props.weightMode === "Liter" && fieldInfoObject.name === "packing_type" && keyString === "Enter") {
      e.preventDefault(); 
      this.props.makeFocusOnParticularFieldForItem(
        this.props.fieldMapping,
        index,
        "liter" 
      );
      return;
    }
    if (fieldInfoObject.name === "packing_type" && keyString === "Enter") {
      e.preventDefault();

      if (this.props.weightMode === "LBH") {
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "l"
        );
      } else if (this.props.pageState?.type_of_shipping === 1) {
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "pkgs"
        );
      } else {
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "pkgs"
        );
      }

      return;
    }
    if (
      this.props.pageState?.role_id !== "1" &&
      this.props.pageState?.role_id !== "2" &&
      this.props.pageState?.pay_type === "4"
    ) {
      if (fieldInfoObject.name === "weight" && keyString === "Enter") {
        e.preventDefault();
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          "new_row"
        );
        return;
      }
    }    

    if (fieldInfoObject.name == "weight" && keyString == "Enter") {
      console.log("In weight :- ",this.props.pageStateArray)
      console.log("In weight  index:- ",index)
      if (
        "rate_info" in this.props.pageStateArray[index] &&
        this.props.pageStateArray[index].unit.toUpperCase() == "F"
      ) {
        let rateInfoObject = this.props.pageStateArray[index]["rate_info"];
        console.log("rate info object Before :- ",rateInfoObject)
        for (let i = 0; i < rateInfoObject.length; i++) {
          console.log("rate info object :- ",rateInfoObject[i])
          if (
            "rate" in rateInfoObject[i] &&
            this.props.pageStateArray[index].truck_size ==
              rateInfoObject[i].truck_size &&
            rateInfoObject[i].unit.toUpperCase() == "F"
          ) {
            this.handleChangeByField("rate", rateInfoObject[i].rate, index);
            // rateValue[rateInfoObject[i].truck_size] = rateInfoObject[i].rate
          }
        }
      }
    }

    // Ewaybill info update block
    if (
      fieldInfoObject.name == "new_row" &&
      this.props.fieldMapping == "eway_bill_no" &&
      keyString == "Enter"
    ) {
      if (
        this.props.pageStateArray[index].new_row == "n" ||
        this.props.pageStateArray[index].new_row == "N"
      ) {
        let apiInputData = [];
        let dummyEwbObject = {};
        let ewbEmpty = false;
        for (let i = 0; i < this.props.pageStateArray.length; i++) {
          dummyEwbObject = this.props.pageStateArray[i];
          if (dummyEwbObject.eway_bill_no == "") {
            ewbEmpty = true;
            break;
          }
          apiInputData.push({ eway_bill_no: dummyEwbObject.eway_bill_no });
        }
        if (!ewbEmpty) {
          this.props.refStoreObject.current.eway_bill_no[index].new_row.blur();
          console.log("api input data", apiInputData);
          console.log("asassadasd", this.props);
          this.props.setOverlay(true);
          let data = {
            // apiUrlTail: "?bilty_no=" + this.props.pageState.bilty_no + "&suffix=" + this.props.pageState.suffix,
            apiUrlTail: "?branch_id=" + JSON.parse(sessionStorage.branch_id).branch_id,
            apiType: "getEwbInfo",
            apiConfig: this.props.apiConfig,
            apiInputData: apiInputData,
          };
          if(this.props.pageState.bilty_id != ""){
            data.apiUrlTail = "?bilty_id=" + this.props.pageState.bilty_id + "&branch_id=" + JSON.parse(sessionStorage.branch_id).branch_id
          }
          this.props.performSuggestions(data);
          return;
        }
      }
    }

    if (
      fieldInfoObject.name == "new_row" &&
      this.props.fieldMapping == "item_in" &&
      keyString == "Enter"
    ) {
      if (
        this.props.pageStateArray[index].new_row == "n" ||
        this.props.pageStateArray[index].new_row == "N"
      ) {
        this.props.fetchChargeRate();
        return;
      }
    }

    // Keyboard navigation block
    if (
      "keyboardNavigationMap" in fieldInfoObject &&
      keyString in fieldInfoObject.keyboardNavigationMap
    ) {
      e.preventDefault();
      /**
       * For all the boxes which are not end box, shift the focus.
       * If it is end box, conditional nav flag needs to be there.
       */
      if (
        !("conditionalNav" in fieldInfoObject.keyboardNavigationMap[keyString])
      ) {
        if (
          fieldInfoObject.name == "weight" &&
          this.props.pageState.pay_type == "4" && process.env.REACT_APP_CLIENT != "nrab" &&
          parseInt(process.env.REACT_APP_BILTY_DISABLE_DYNAMIC_TABLE_IN_TBB_MODIFY)
        ) {
          this.props.makeFocusOnParticularFieldForItem(
            this.props.fieldMapping,
            index,
            "new_row"
          );
          return;
        }
        if (
          fieldInfoObject.name == "unit" &&
          (this.props.pageStateArray[index].unit == "f" ||
            this.props.pageStateArray[index].unit == "F")
        ) {
          this.props.makeFocusOnParticularFieldForItem(
            this.props.fieldMapping,
            index,
            "vehicle_type"
          );
          return;
        }
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index,
          fieldInfoObject.keyboardNavigationMap[keyString].nextField
        );
        return;
      }

      /***
       * If end row or not
       */
      if (index + 1 == totalLength) {
        let valueForNav = this.props.pageStateArray[index].new_row;
        if (valueForNav == "y" || valueForNav == "Y") {
          /**
           * Check if any field is empty and don't let the row add
           * if any field is empty.
           */
          for (var item_index in this.props.pageStateArray) {
            let item = this.props.pageStateArray[item_index];
            // for (var key in item) {
            //   if (item[key] == "") {
            //     if (key == "rate_info"){
            //       continue
            //     }
            //     if (key == "truck_size"){
            //       continue
            //     }
            //     return;
            //   }
            // }

            const skipFieldsByWeightMode = {
              LBH: ["cft", "inch_cm", "vehicle_size", "rate_info", "liter", "vehicle_type", "box_capacity"],
              CFT: ["l", "b", "h", "inch_cm", "rate_info", "vehicle_size", "liter", "vehicle_type", "box_capacity"],
              Liter: ["l", "b", "h", "cft", "inch_cm", "rate_info", "vehicle_size", "vehicle_type", "box_capacity"],
              Normal: ["l", "b", "h", "cft", "inch_cm", "rate_info", "vehicle_size", "liter", "vehicle_type", "box_capacity"],
            };
            
            // const skipFieldsByShippingType = {
            //   1: ["l", "b", "h", "cft", "inch_cm", "truck_size", "liter"],
            // };

            const skipFieldsByShippingType = {};  // prevent error, not used anymore
            
            const weightModeSkipSet = new Set(skipFieldsByWeightMode[weightMode] || []);
            const shippingTypeSkipSet = new Set(skipFieldsByShippingType[this.props.pageState?.type_of_shipping] || []);
            
            for (const key in item) {
              if (weightModeSkipSet.has(key) || shippingTypeSkipSet.has(key)) {
                continue;
              }

              if (item[key] === "") {
                console.log(`Field "${key}" is empty. Row will not be added.`);
                return; 
              }
            }
          }
          this.handleAddRow();
          return;
        } else if (valueForNav == "n" || valueForNav == "N") {
          /**
           * Make focus to anywhere else.
           */
          this.props.makeFocusOnParticularField(
            fieldInfoObject.keyboardNavigationMap[keyString].nextFieldOnPage
          );
          return;
        }
      } else {
        // Not end row
        this.props.makeFocusOnParticularFieldForItem(
          this.props.fieldMapping,
          index + 1,
          fieldInfoObject.keyboardNavigationMap[keyString].nextField
        );
        return;
      }
    }
  };

  getAdditionalInfoForSuggestionFetch = () => {
    let additionalInfoObject = {};
    additionalInfoObject.station_from = this.props.pageState.station_from;
    additionalInfoObject.station_to = this.props.pageState.station_to;
    if (this.props.pageState.pay_type == "4") {
      additionalInfoObject.consignor_id = this.props.pageState.consignor_id;
      additionalInfoObject.consignee_id = null;
    } else {
      additionalInfoObject.consignor_id = null;
      additionalInfoObject.consignee_id = this.props.pageState.consignee_id;
    }
    return additionalInfoObject;
  };

  getShouldRenderSugggestions = (fieldInfo) => {
    if ("suggestionsOff" in fieldInfo && fieldInfo.suggestionsOff == true) {
      return false;
    } else {
      return true;
    }
  };

  checkToBeBilledCondition = (fieldInfo, idx) => {
    //This If Removed to see Rate and Amount value by normal user 

    if (
      String(this.props.pageState.pay_type) === "4" && 
      (fieldInfo.name === "rate" || fieldInfo.name === "amount") &&
      !["1", "2"].includes(String(this.props.pageState.role_id))
    ) {
      return false;
    }
    
    if (
      String(this.props.pageStateArray[idx].unit).toUpperCase() != "F" &&
      fieldInfo.name == "truck_size"
    ) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const { weightMode } = this.props; 
    const excludedHeaders = [ "L", "B", "H", "Inch_CM", "CFT", "Liter"];
    const excludedLabels = [ "L", "B", "H", "INCH/CM", "CFT", "Liter"];
  
    const filteredTableHeader = this.props.tableHeader.filter((header) => {
  
      const label = header.label.trim();

      if (label === "Total kms") {
        const { type_of_shipping, is_wipro, type_of_weight } = this.props.pageState;
        return (
          (type_of_shipping === 1 && is_wipro === true) ||
          type_of_weight === 15
        );
      }
  
      // if (this.props.pageState?.type_of_shipping === 1) {
      //   return !excludedHeaders.includes(label);
      // }
  
      const weightExclusions = {
        11: ["L", "B", "H", "Liter", "Box Size", "Vehicle Size", "Vehicle Type"],
        12: ["CFT", "Liter", "Box Size", "Vehicle Size", "Vehicle Type"],
        13: ["L", "B", "H", "CFT", "Inch_CM", "Liter", "Box Size", "Vehicle Size", "Vehicle Type"],
        14: ["L", "B", "H", "CFT", "Inch_CM", "Box Size", "Vehicle Size", "Vehicle Type"],
        15: ["L", "B", "H", "CFT", "Inch_CM", "Liter"],  
      };
  
      if (
        label === "Vehicle Type" &&
        this.props.pageState?.type_of_shipping === 1 &&
        this.props.pageState?.is_wipro === true
      ) {
        return true;
      }

      return !weightExclusions[this.props.pageState?.type_of_weight]?.includes(label);
    });
    

    return (
      <div>
        <div className="dt-container  responsive-table">
          <div className="row clearfix">
            <div className="col-md-12 column">
              <table
                className="table table-bordered table-hover"
                id="tab_logic"
              >
                <thead>
                  <tr>
                    <th />
                    {filteredTableHeader.map((item) => (
                      <th className={item.className} key={item.label}>
                        {" "}
                        {item.label}{" "}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {this.props.pageStateArray.map((item, idx) => (
                    <tr id="addr0" key={idx}>
                      <td>
                        <button
                          className="item-remove-btn"
                          onClick={this.handleRemoveSpecificRow(idx)}
                        >
                          -
                        </button>
                      </td>

                      <td>{idx + 1}</td>
                      {this.props.tableItems.map((row, index) => {

                        const trimmedLabel = row.label.trim();

                        if (row.name === "total_kms" || trimmedLabel === "Total KMs") {
                          const { type_of_shipping, is_wipro, type_of_weight } = this.props.pageState;

                          const shouldShowTotalKms =
                            type_of_weight === 15 || (type_of_shipping === 1 && is_wipro === true);

                          if (!shouldShowTotalKms) {
                            return null;
                          }
                        }

                        // Do NOT render rows or inputs for excluded labels if type_of_shipping === 1
                        // if (
                        //   this.props.pageState?.type_of_shipping === 1 &&
                        //   excludedLabels.includes(row.label)
                        // ) {
                        //   return null;
                        // }
                        // weightMode condition for excluding CFT or L/B/H fields
                        if (
                          this.props.pageState?.type_of_weight === 11 &&
                          (
                            ['L', 'B', 'H', 'Liter', 'Vehicle Size', 'Box Size'].includes(trimmedLabel) ||
                            (
                              trimmedLabel === 'Vehicle Type' &&
                              !(
                                this.props.pageState?.type_of_shipping === 1 &&
                                this.props.pageState?.is_wipro === true
                              )
                            )
                          )
                        ) {
                          return null;
                        }                      
                        if (
                          this.props.pageState?.type_of_weight === 12 &&
                          (
                            ['CFT', 'Liter', 'Vehicle Size', 'Box Size'].includes(trimmedLabel) ||
                            (
                              trimmedLabel === 'Vehicle Type' &&
                              !(
                                this.props.pageState?.type_of_shipping === 1 &&
                                this.props.pageState?.is_wipro === true
                              )
                            )
                          )
                        ) {
                          return null;
                        }
                        if (
                          this.props.pageState?.type_of_weight === 13 &&
                          (
                            ['L', 'B', 'H', 'CFT', 'INCH/CM', 'Liter', 'Vehicle Size', 'Box Size'].includes(trimmedLabel) ||
                            (
                              trimmedLabel === 'Vehicle Type' &&
                              !(
                                this.props.pageState?.type_of_shipping === 1 &&
                                this.props.pageState?.is_wipro === true
                              )
                            )
                          )
                        ) {
                          return null;
                        }
                        if (
                          this.props.pageState?.type_of_weight === 14 &&
                          (
                            ['L', 'B', 'H', 'CFT', 'INCH/CM', 'Vehicle Size', 'Box Size'].includes(trimmedLabel) ||
                            (
                              trimmedLabel === 'Vehicle Type' &&
                              !(
                                this.props.pageState?.type_of_shipping === 1 &&
                                this.props.pageState?.is_wipro === true
                              )
                            )
                          )
                        ) {
                          return null;
                        }
                        if (
                          this.props.pageState?.type_of_weight === 15 &&
                          ['L', 'B', 'H', 'CFT', 'INCH/CM', 'Liter'].includes(trimmedLabel)
                        ) {
                          return null;
                        }


                        if (row["type"] === "dropdown") {
                          return (
                            <td key={idx + row.name}>
                              {this.checkToBeBilledCondition(row, idx) && (
                                <select
                                  className={row["inputClassName"]}
                                  onChange={(e) => {
                                    const { name, value } = e.target;
                                    this.handleChangeByField(
                                      row["name"],
                                      value,
                                      idx
                                    );
                                  }}
                                  // have introduced new function to disable individual drop downs
                                  disabled={
                                    this.props.pageMode == "view" ||
                                    this.props.disabledFlag == "true"||
                                    ("isDisabled" in row && row.isDisabled({ pageState: this.props.pageState, pageMode: this.props.pageMode, idx })) 
                                      ? "disabled"
                                      : ""
                                  }
                                  value={
                                    this.props.pageStateArray[idx][row["name"]]
                                  }
                                  ref={(a) =>
                                    this.props.storeInputReferenceForSelectForDynamicTable(
                                      a,
                                      row["name"],
                                      idx,
                                      this.props.fieldMapping
                                    )
                                  }
                                  onKeyPress={(e) => {
                                    this.onKeyPress(
                                      e,
                                      idx,
                                      this.props.pageStateArray.length,
                                      row
                                    );
                                  }}
                                >
                                  {row.label === "Unit"
                                    ? // Only dynamically filter this dropdown if label is 'Unit'
                                      (this.props.pageState?.type_of_shipping === 1
                                        ? row["dropdown_items"].filter(item => ['C', 'F', 'W'].includes(item.value))
                                        : this.props.pageState?.type_of_shipping === 2
                                        ? row["dropdown_items"].filter(item => ['C', 'W'].includes(item.value))
                                        : row["dropdown_items"]
                                      ).map((dropdown_item) => (
                                        <option
                                          value={dropdown_item.value}
                                          key={`${dropdown_item.value}-${row.name}-${idx}`}
                                        >
                                          {dropdown_item.label}
                                        </option>
                                      ))
                                    : row["dropdown_items"].map((dropdown_item) => (
                                      <option
                                        value={dropdown_item.value}
                                        key={`${dropdown_item.value}-${row.name}-${idx}`}
                                      >
                                        {dropdown_item.label}
                                      </option>
                                  ))}
                                </select>
                              )}
                            </td>
                          );
                        } else {
                          return (
                            <td key={idx + row.name}>
                              {this.checkToBeBilledCondition(row, idx) && (
                                <Autosuggest
                                  id={row["name"] + "#" + idx}
                                  // suggestions={this.props.suggestions}
                                  suggestions = {(this.props.suggestions != undefined) ? this.props.suggestions : ""}  // changes made for removing error that was caused by undefined suggestion
                                  onSuggestionsFetchRequested={(a) =>
                                    this.props.onSuggestionsFetchRequested(
                                      a,
                                      (b) =>
                                        this.props.suggestionFetchApi(
                                          row,
                                          b,
                                          this.getAdditionalInfoForSuggestionFetch()
                                        )
                                    )
                                  }
                                  onSuggestionsClearRequested={() =>
                                    this.props.onSuggestionsClearRequested(row)
                                  }
                                  shouldRenderSuggestions={() =>
                                    this.getShouldRenderSugggestions(row)
                                  }
                                  getSuggestionValue={(suggestion) =>
                                    suggestion[row.suggestionKeyword]
                                  }
                                  onSuggestionSelected={(a, b) =>
                                    this.props.getSuggestionValue(
                                      b.suggestion,
                                      row,
                                      this.props.performSuggestions,
                                      (d) =>
                                        this.updateSuggestionValueInState(
                                          idx,
                                          d
                                        ),
                                      idx
                                    )
                                  }
                                  renderSuggestion={(a) =>
                                    this.props.renderSuggestion(a, row)
                                  }
                                  highlightFirstSuggestion={true}
                                  ref={(a) => {
                                    this.props.storeInputReference(
                                      a,
                                      true,
                                      this.props.fieldMapping
                                    );
                                    if (
                                      "newRowFocus" in row &&
                                      row["newRowFocus"]
                                    ) {
                                      if (
                                        a != null &&
                                        this.state.focusOnAddRow
                                      ) {
                                        a.input.focus();
                                        this.setState({
                                          focusOnAddRow: false,
                                        });
                                      }
                                    }
                                  }}
                                  inputProps={{
                                    placeholder: row["placeHolder"], // Ensure this is set correctly
                                    value: String(this.props.pageStateArray[idx][row["name"]]),
                                    onChange: (a, b) => {
                                      this.props.onChangeAutoSuggest(
                                        a,
                                        b,
                                        row,
                                        (c, d) =>
                                          this.handleChangeByField(c, d, idx)
                                      );
                                    },
                                    onBlur: () => {
                                      row["toValidate"]
                                        ? this.props.onblurValidatorForTable(
                                            this.props.fieldMapping,
                                            idx,
                                            row["name"]
                                          )
                                        : {};
                                    },
                                    onKeyDown: (e) => {
                                      this.onKeyPress(
                                        e,
                                        idx,
                                        this.props.pageStateArray.length,
                                        row
                                      );
                                    },
                                    disabled:
                                      this.props.pageMode == "view" ||
                                      this.props.disabledFlag == "true" ||
                                      ("isDisabled" in row && row.isDisabled({ pageState: this.props.pageState, pageMode: this.props.pageMode, idx })) 
                                      ? "disabled"
                                        : "",
                                    className: row.className,
                                  }}
                                />
                              )}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))}
                  <tr>
                    <td>
                      <button
                        onClick={this.handleAddRow}
                        className="item-add-btn"
                      >
                        +
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <button
                onClick={this.handleRemoveRow}
                className="btn btn-danger float-right item-remove-btn"
              >
                Delete Last Row
              </button> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DynamicTable;
